import _defineProperty from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _objectWithoutProperties from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "bgColor", "transform", "textColor", "justify", "shadow", "height", "isLoading"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Button } from '@chakra-ui/react';
import { When } from '../utils/when';
import { LoadingDot } from '../loading-dot';
export var ButtonPrimary = function ButtonPrimary(_ref) {
  var children = _ref.children,
      _ref$bgColor = _ref.bgColor,
      bgColor = _ref$bgColor === void 0 ? 'purple.primary' : _ref$bgColor,
      _ref$transform = _ref.transform,
      transform = _ref$transform === void 0 ? 'uppercase' : _ref$transform,
      _ref$textColor = _ref.textColor,
      textColor = _ref$textColor === void 0 ? 'white' : _ref$textColor,
      _ref$justify = _ref.justify,
      justify = _ref$justify === void 0 ? 'center' : _ref$justify,
      _ref$shadow = _ref.shadow,
      shadow = _ref$shadow === void 0 ? '0' : _ref$shadow,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '48px' : _ref$height,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs(Button, _objectSpread(_objectSpread({
    p: "2",
    mb: "8px",
    fontWeight: "bold",
    fontSize: "md",
    h: height,
    w: "100%",
    minW: {
      base: '240px',
      sm: '286px'
    },
    outline: "none",
    textTransform: transform,
    display: "flex",
    justifyContent: justify,
    color: textColor,
    borderRadius: "full",
    bg: bgColor,
    boxShadow: shadow,
    transition: "all 200ms ease-out",
    _focus: {
      outline: 'none'
    },
    _hover: {
      boxShadow: 'lg'
    },
    _disabled: {
      opacity: '50%'
    }
  }, props), {}, {
    type: "submit",
    children: [/*#__PURE__*/_jsx(When, {
      value: !isLoading,
      children: children
    }), /*#__PURE__*/_jsx(When, {
      value: isLoading,
      children: /*#__PURE__*/_jsx(LoadingDot, {
        color: textColor
      })
    })]
  }));
};